import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { IScheduledTransfer } from '../../../types/transfer';
import { RootState } from '../..';

interface ITransferData {
  data?: IScheduledTransfer[];
  meta?: {
    total?: number;
    perPage?: number;
    totalPages?: number;
    page?: number;
  };
}
interface IGetScheduledTransfersResponse {
  status?: boolean;
  message?: string;
  data?: ITransferData;
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetScheduledTransfersResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getScheduledTransfersAsync = createAsyncThunk(
  'scheduledTransfers',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get(`/transfers/scheduled`, config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const scheduledTransfersGetSlice = createSlice({
  name: 'scheduledTransfers/get',
  initialState,
  reducers: {
    resetGetScheduledTransfers: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScheduledTransfersAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getScheduledTransfersAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetScheduledTransfersResponse;
      })
      .addCase(getScheduledTransfersAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetScheduledTransfersResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetScheduledTransfers } =
  scheduledTransfersGetSlice.actions;

export default scheduledTransfersGetSlice.reducer;
